/**
 * el-scrollbar 组件在无滚动条时还会加上margin样式，导致无滚动条时样式外溢
 * fix: 容器无滚动条时，去除margin样式
 */
import ElScrollBar from "element-ui/lib/scrollbar";

const update = ElScrollBar.methods.update;
export default {
  name: "BsScrollbar",
  extends: ElScrollBar,
  methods: {
    // 重构 element scroll-bar update method
    update() {
      update.call(this);
      const wrap = this.wrap;
      // 获取容器上的style值
      const styles = wrap
        .getAttribute("style")
        .split(";")
        .filter((style) => !!style);
      // 取出其中的 margin-bottom margin-right 样式
      const MARGIN_BOTTOM_STYLE = styles.filter(
        (style) => style.indexOf("margin-bottom") !== -1
      )[0];
      const MARGIN_RIGHT_STYLE = styles.filter(
        (style) => style.indexOf("margin-right") !== -1
      )[0];

      // 去除margin样式
      let otherStyles = styles.filter(
        (style) => style.indexOf("margin") === -1
      );
      const heightPercentage = (wrap.clientHeight * 100) / wrap.scrollHeight;
      const widthPercentage = (wrap.clientWidth * 100) / wrap.scrollWidth;
      if (heightPercentage < 100) {
        otherStyles.push(MARGIN_RIGHT_STYLE);
      }
      if (widthPercentage < 100) {
        otherStyles.push(MARGIN_BOTTOM_STYLE);
      }
      wrap.setAttribute("style", otherStyles.join(";"));
    },
  },
};
